module.exports = __webpack_public_path__ + "static/media/trencin.3a832f49.jpg";